const env = process.env.NODE_ENV
const IP = {
  development: { // 本地开发环境
    baseIP: 'http://47.94.233.119:8089/appspbcn/',
    imgUrl: 'https://cdn.spbcn.org/spbcnWeb/uie/'
  },
  production: { // 生产环境
    baseIP: 'http://47.94.233.119:8089/appspbcn/',
    imgUrl: 'https://cdn.spbcn.org/spbcnWeb/uie/'
  },
  test: { // 测试环境
    baseIP: 'http://47.94.233.119:8089/appspbcn/',
    imgUrl: 'https://cdn.spbcn.org/spbcnWeb/uie/'
  }
}
export default IP[env]
